import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import diagnosisIcon from '@/imgs/diagnosis-icon.png';
import configIcon from '@/imgs/config-icon.png';
import insightsIcon from '@/imgs/insights-icon.png';
import { EXTERNAL_USER_ID } from '@/config/env';
import { getCopilotValueByTaskIdApi } from '@/api/copilot';

const FunctionButtons: React.FC<{ taskId: string }> = ({ taskId }) => {
  const [aiAdvisorCustomAssetAllocation, setAiAdvisorCustomAssetAllocation] = useState(false);
  const navigate = useNavigate();

  const handleDiagnosis = () => {
    navigate('/aiAdvisorDiagnosis', { state: { taskId } });
  };

  const handleCustomAssetAllocation = () => {
    navigate('/aiAdvisorCustomAssetAllocation', {
      state: { taskId, hasData: aiAdvisorCustomAssetAllocation }
    });
  };

  const handleRiskAssessment = () => {
    navigate('/aiAdvisorRiskAssessment', {
      state: { taskId }
    });
  };

  useEffect(() => {
    if (taskId) {
      getCopilotValueByTaskIdApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 4,
        taskId
      }).then(res => {
        setAiAdvisorCustomAssetAllocation(res.status !== 'false');
      });
    }
  }, [taskId]);

  return (
    <div className="rounded-lg border border-gray-100 bg-white px-12 py-4">
      <div className="flex items-center justify-between gap-2">
        {/* 持仓深度诊断 */}
        <div className="flex cursor-pointer flex-col items-center gap-1" onClick={handleDiagnosis}>
          <div className="h-9 w-9">
            <img src={diagnosisIcon} alt="诊断" className="h-full w-full object-cover" />
          </div>
          <span className="text-sm text-gray-800">持仓深度诊断</span>
        </div>

        {/* 定制资产配置 */}
        <div
          className="flex cursor-pointer flex-col items-center gap-1"
          onClick={handleCustomAssetAllocation}
        >
          <div className="h-9 w-9">
            <img src={configIcon} alt="配置" className="h-full w-full object-cover" />
          </div>
          <span className="text-sm text-gray-800">定制资产配置</span>
        </div>

        {/* AI投顾洞察 */}
        <div
          className="flex cursor-pointer flex-col items-center gap-1"
          onClick={handleRiskAssessment}
        >
          <div className="h-9 w-9">
            <img src={insightsIcon} alt="洞察" className="h-full w-full object-cover" />
          </div>
          <span className="text-sm text-gray-800">AI投顾洞察</span>
        </div>
      </div>
    </div>
  );
};

export default FunctionButtons;
